<template>
    <div>
        <upload-modal
            v-if="uploadModalVisible"
            @close="uploadModalVisible = false"
            @uploaded="refreshFiles"
        />

        <edit-description-modal
            v-if="editModalVisible"
            :file="editingFile"
            @close="editModalVisible = false; editingFile = null"
            @updated="refreshFiles"
        />

        <delete-file-modal
            v-if="deleteModalVisible"
            :file="deletingFile"
            @close="deleteModalVisible = false; deletingFile = null"
            @confirm="confirmDelete"
        />

        <menu-bar
            @upload="uploadModalVisible = true"
            @search="searchQuery = $event"
        />

        <div class="border-b-[1px] border-white w-[90%] mx-auto flex justify-end mt-[16px] mb-[16px]">
            <div class="text-white">
                <span class="text-[28px] font-semibold">{{ filteredFiles.length }}</span> файлів
            </div>
        </div>

        <div class="w-[90%] mx-auto mt-3 rounded-[10px] overflow-hidden">
            <table class="w-full">
                <thead>
                    <tr class="text-white border-b-[1px] border-[#FFF] border-opacity-10">
                        <th class="px-3 py-2 text-start font-medium text-sm w-[20%]">Назва файлу</th>
                        <th class="px-3 py-2 text-start font-medium text-sm w-[25%]">S3 ключ</th>
                        <th class="px-3 py-2 text-start font-medium text-sm w-[30%]">Опис</th>
                        <th class="px-3 py-2 text-start font-medium text-sm w-[15%]">Дата завантаження</th>
                        <th class="px-3 py-2 text-end font-medium text-sm w-[10%]"></th>
                    </tr>
                </thead>
                <tbody>
                    <file-row
                        v-for="file in filteredFiles"
                        :key="file.id"
                        :file="file"
                        @edit="openEditModal"
                        @delete="openDeleteModal"
                    />
                </tbody>
            </table>
        </div>

        <div v-if="files.length === 0 && !loading" class="w-full mt-[14px] flex items-center justify-center">
            <p class="text-[#A3A3C2] text-[16px]">Файли не знайдено</p>
        </div>

        <div v-if="loading" class="w-full mt-[14px] flex items-center justify-center">
            <p class="text-[#A3A3C2] text-[16px]">Завантаження...</p>
        </div>
    </div>
</template>

<script>
    import { ref, computed, onMounted } from 'vue'
    import { getFileList, deleteFile } from './services/apiRequests'
    import MenuBar from './components/MenuBar.vue'
    import FileRow from './components/FileRow.vue'
    import UploadModal from './components/UploadModal.vue'
    import EditDescriptionModal from './components/EditDescriptionModal.vue'
    import DeleteFileModal from './components/DeleteFileModal.vue'

    export default {
        name: 'FileStorage',

        components: {
            MenuBar,
            FileRow,
            UploadModal,
            EditDescriptionModal,
            DeleteFileModal
        },

        setup() {
            const files = ref([])
            const loading = ref(false)
            const searchQuery = ref('')
            const uploadModalVisible = ref(false)
            const editModalVisible = ref(false)
            const deleteModalVisible = ref(false)
            const editingFile = ref(null)
            const deletingFile = ref(null)

            const filteredFiles = computed(() => {
                const q = searchQuery.value?.toLowerCase().trim()
                if (!q) return files.value
                return files.value.filter(f =>
                    (f.file_name || '').toLowerCase().includes(q) ||
                    (f.description || '').toLowerCase().includes(q) ||
                    (f.s3_key || '').toLowerCase().includes(q)
                )
            })

            const refreshFiles = async () => {
                loading.value = true
                try {
                    const res = await getFileList(500, 0)
                    files.value = Array.isArray(res.data) ? res.data : []
                } catch (err) {
                    console.error('Failed to load files:', err)
                    files.value = []
                } finally {
                    loading.value = false
                }
            }

            const openEditModal = (file) => {
                editingFile.value = file
                editModalVisible.value = true
            }

            const openDeleteModal = (file) => {
                deletingFile.value = file
                deleteModalVisible.value = true
            }

            const confirmDelete = async () => {
                if (!deletingFile.value?.id) return
                try {
                    await deleteFile(deletingFile.value.id)
                    deleteModalVisible.value = false
                    deletingFile.value = null
                    await refreshFiles()
                } catch (err) {
                    console.error('Failed to delete file:', err)
                }
            }

            onMounted(refreshFiles)

            return {
                files,
                loading,
                searchQuery,
                filteredFiles,
                uploadModalVisible,
                editModalVisible,
                deleteModalVisible,
                editingFile,
                deletingFile,
                refreshFiles,
                openEditModal,
                openDeleteModal,
                confirmDelete
            }
        }
    }
</script>
